import React from "react";
import siteImages from "../assets/data/site-images.json";

const url = (name, width, ext) => `${process.env.PUBLIC_URL}/images/site/${name}-${width}.${ext}`;
const srcSet = (name, widths, ext) => widths.map((w) => `${url(name, w, ext)} ${w}w`).join(", ");

// Responsive AVIF/WebP image from the set generated by `npm run images`
// (see SITE_IMAGES in scripts/optimize-images.js).
function SitePicture({ name, sizes = "100vw", alt, loading = "lazy", className = "", ...rest }) {
  const image = siteImages[name];
  if (!image) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(`SitePicture: "${name}" is not in site-images.json; run npm run images`);
    }
    return null;
  }
  return (
    <picture>
      <source type="image/avif" srcSet={srcSet(name, image.widths, "avif")} sizes={sizes} />
      <source type="image/webp" srcSet={srcSet(name, image.widths, "webp")} sizes={sizes} />
      <img
        src={url(name, image.width, "webp")}
        width={image.width}
        height={image.height}
        alt={alt}
        loading={loading}
        decoding="async"
        className={className}
        {...rest}
      />
    </picture>
  );
}

// Client logos are keyed by their original filename in client-data.json.
export const clientLogoName = (filename) => `clients/${filename.replace(/\.[^.]+$/, "")}`;

export default SitePicture;
